export const TITLE = 'Map Teams';

export const mapTeamsModalPoints = [
    'Map employees to their managers',
    'Let managers Reward approvals, eNPS, Pulses and more',
    'Analyze team engagement at a department level',
];
